/* CUSTOMERS */

import BasicLayout from '@/views/layouts/basic.vue';
import quotesOverview from '@/views/quotes/list.vue';
import quotesDetails from '@/views/quotes/details.vue';
import customerOverview from '@/views/quotes/customers/list.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'quotes',
  name: 'quotes',
  meta: {title: 'Offertes'},
  redirect: '/quotes/overzicht',
  component: BasicLayout,
  children: [
      // Overview routes
    {
      path: 'overzicht',
      name: 'quotes.overview',
      meta: {title: 'Offertes'},
      component: quotesOverview,
      children: [
        {
          path: ':status',
          name: 'quotes.overview.status',
          meta: {title: 'Offertes'},
          component: quotesOverview,
        },
      ],
    },
    // Quote info page
    {
      path: 'quotes/add/:id/:paid/',
      name: 'quotes.add',
      meta: {title: 'Offerte'},
      component: quotesDetails,
    },
    {
      path: 'quotes/add/customers/',
      name: 'quotes.add.customers.list',
      meta: {title: 'Offerte'},
      component: customerOverview,
      children: [
        {
          path: 'partner/:partnerId',
          name: 'quotes.add.customers.list.partner',
          meta: {title: 'Offertes'},
          component: customerOverview,
        },
      ],
    },
    {
      path: '/quotes/:id/edit',
      name: 'quotes.edit',
      meta: {title: 'Offerte'},
      component: quotesDetails,
    },
  ],
};
